<header>
  <h2>{{ "taxReturns.missing-information" | transloco }}</h2>
</header>

@if (!taxReturnWithMissingInfo) {
<div class="ui active centered inline loader"></div>
} @if (taxReturnWithMissingInfo) {
<div class="body">
  @if (taxReturnWithMissingInfo && taxReturnWithMissingInfo.categories.length
  === 0) {
  <div id="no-missing-info">
    {{ "taxReturns.no-missing-information" | transloco }}
  </div>
  }
  <div class="left-bar hidden-scrollbar">
    @for (category of taxReturnWithMissingInfo.categories; track category) {
    <div class="category">
      <div class="title" (click)="category.isCollapsed = !category.isCollapsed">
        <i
          class="chevron icon"
          [ngClass]="{ down: category.isCollapsed, up: !category.isCollapsed }"
        ></i>
        {{ category.name }}
      </div>
      @for (subCategory of category.subcategories; track subCategory) {
      <div [hidden]="category.isCollapsed" class="subcategory">
        <div
          class="title"
          (click)="subCategory.isCollapsed = !subCategory.isCollapsed"
        >
          <i
            class="chevron icon"
            [ngClass]="{
              down: subCategory.isCollapsed,
              up: !subCategory.isCollapsed
            }"
          ></i>
          {{ subCategory.name }}
        </div>
        @for (group of subCategory.groups; track group) {
        <div [hidden]="subCategory.isCollapsed" class="group">
          @if (group.id) {
          <div class="title" (click)="group.isCollapsed = !group.isCollapsed">
            <i
              class="chevron icon"
              [ngClass]="{ down: group.isCollapsed, up: !group.isCollapsed }"
            ></i>
            {{ group.name }}
          </div>
          } @for (subGroup of group.subgroups; track subGroup) {
          <div [hidden]="group.isCollapsed" class="subgroup">
            <div
              class="title"
              (click)="subGroup.isCollapsed = !subGroup.isCollapsed"
            >
              <i
                class="chevron icon"
                [ngClass]="{
                  down: subGroup.isCollapsed,
                  up: !subGroup.isCollapsed
                }"
              ></i>
              {{ subGroup.name }}
            </div>
            @for (_question of subGroup.questions; track _question) {
            <div
              (click)="
                selectQuestion(
                  _question,
                  category,
                  subCategory,
                  group,
                  subGroup
                )
              "
              class="question"
              [hidden]="subGroup.isCollapsed"
              [ngClass]="{
                active:
                  _question.id === question?.id &&
                  question.category?.id === category?.id &&
                  question.subcategory?.id === subCategory?.id &&
                  (group.id ? question.group?.id === group?.id : true) &&
                  question.subgroup?.id === subGroup?.id,
                inactive: hasClosedAll(_question)
              }"
            >
              {{ _question.question }}
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
  @if (question) {
  <div class="main-content">
    <header>
      <h3>{{ question?.question }}</h3>
    </header>
    <div class="list-container">
      <div class="list-inner-cont">
        @for (answer of question?.answers; track answer) { @for (answerFlag of
        answer?.answerFlags; track answerFlag) {
        <div class="flag-item" [ngClass]="{ disabled: answerFlag?.status > 0 }">
          <div class="comment">
            <div class="header">
              <div class="ui label">
                {{ answerFlag.flag.flagMessage }}
              </div>
              <div class="commenter-name">
                {{ answerFlag?.parentComment?.author }}
              </div>
              <div class="date">{{ answerFlag?.parentComment?.date }}</div>
            </div>
            <div class="commenter-role">
              <div>
                <i
                  class="small circle icon"
                  [ngClass]="{
                    preparer: answerFlag?.parentComment?.role === 'Preparer',
                    reviewer: answerFlag?.parentComment?.role === 'Reviewer'
                  }"
                ></i>
                {{ answerFlag?.parentComment?.role }}
              </div>
              <div class="comment-date">
                {{ answerFlag?.parentComment?.createdAtString }}
              </div>
            </div>
            <div class="labels">
              <div
                class="ui label"
                attr.data-content="{{ answerFlag?.groupName }}{{
                  answerFlag?.groupName && answerFlag?.subGroupName ? ' - ' : ''
                }}{{ answerFlag?.subGroupName }}{{
                  answerFlag?.rowIndex != null
                    ? ' - row ' + (answerFlag?.rowIndex + 1)
                    : undefined
                }}"
                title="{{ answerFlag?.groupName }}{{
                  answerFlag?.groupName && answerFlag?.subGroupName ? ' - ' : ''
                }}{{ answerFlag?.subGroupName }}{{
                  answerFlag?.rowIndex != null
                    ? ' - row ' + (answerFlag?.rowIndex + 1)
                    : undefined
                }}"
              >
                {{ answerFlag?.question?.question }}
              </div>
              @if (answerFlag?.answer?.answer) {
              <div class="answer label">
                {{ answerFlag?.answer?.answer }}
              </div>
              }
            </div>
            @if (answerFlag.parentComment) {
            <div class="comment-text">
              <app-comment
                [comment]="answerFlag.parentComment"
                [documents]="taxReturn.documents"
              ></app-comment>
            </div>
            } @for (comment of answerFlag?.parentComment?.comments; track
            comment) {
            <div class="reply comment">
              <div class="header">
                <div class="commenter-name">{{ comment?.author }}</div>
                <div class="date">{{ comment?.date }}</div>
              </div>
              <div class="commenter-role">
                <div>
                  <i
                    class="small circle icon"
                    [ngClass]="{
                      preparer: comment?.role === 'Preparer',
                      reviewer: comment?.role === 'Reviewer'
                    }"
                  ></i>
                  {{ comment?.role }}
                </div>
              </div>
              <div class="comment-text">
                <app-comment
                  [comment]="comment"
                  [documents]="taxReturn.documents"
                ></app-comment>
              </div>
            </div>
            }
            <div class="reply-comment">
              @if (!readonly() && answerFlag.replyTo) {
              <div>
                <textarea
                  [(ngModel)]="answerFlag.replyComment"
                  placeholder="Type your comment here..."
                ></textarea>
                <div class="actions-btn-cont">
                  <div style="flex:1"></div>
                  <span
                    (click)="cancelReply(answerFlag)"
                    class="cancel-reply"
                    >{{ "taxReturns.cancel" | transloco }}</span
                  >
                  <span
                    (click)="replyToFlag(answerFlag)"
                    class="reply-only"
                    [ngClass]="{ disabled: !answerFlag.replyComment.message }"
                    >{{ "taxReturns.reply-only" | transloco }}</span
                  >
                  <div
                    (click)="replyToFlag(answerFlag, true)"
                    class="ui primary background button"
                    [ngClass]="{
                      disabled: !answerFlag.replyComment.message,
                      loading: isSavingReply
                    }"
                  >
                    {{ "taxReturns.reply-and-close" | transloco }}
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
          @if (!readonly() && answerFlag?.status === 0 && !answerFlag.replyTo) {
          <span (click)="answerFlag.replyTo = true" class="respond">{{
            "taxReturns.reply" | transloco
          }}</span>
          }
        </div>
        } @for (answerWarning of answer?.answerWarnings; track answerWarning) {
        <div>
          <div
            class="warning-item"
            [ngClass]="{ disabled: answerWarning?.status !== 0 }"
          >
            <div class="header">
              <div class="warning-type">
                <div class="ui orange label">
                  {{ "taxReturns.review" | transloco }}
                </div>
                {{ answerWarning?.warning?.message }}
              </div>
              <div class="warning-date">
                {{ answerWarning?.createdAtString }}
              </div>
            </div>
            <div class="labels">
              <span class="ui label">{{ answerWarning?.question }}</span>
              @if (answerWarning?.answer?.answer) {
              <span class="answer label">{{
                answerWarning?.answer?.answer
              }}</span>
              }
            </div>
            <pre class="warning-message">{{
              answerWarning?.warningMessage
            }}</pre>
            @for (comment of answerWarning.replies; track comment) {
            <div class="comment">
              <div class="commenter-name">{{ comment?.author }}</div>
              <div class="commenter-role">
                <div>
                  <i
                    class="small circle icon"
                    [ngClass]="{
                      preparer: comment?.role === 'Preparer',
                      reviewer: comment?.role === 'Reviewer'
                    }"
                  ></i>
                  {{ comment?.role }}
                </div>
                <div class="comment-date">{{ comment?.date }}</div>
              </div>
              <div class="comment-text">
                <app-comment
                  [comment]="comment"
                  [documents]="taxReturn.documents"
                ></app-comment>
              </div>
            </div>
            }
            <div class="reply-comment">
              @if (answerWarning?.replyTo) {
              <div>
                <textarea
                  [(ngModel)]="answerWarning.replyComment"
                  placeholder="Type your comment here..."
                ></textarea>
                <div class="actions-btn-cont">
                  <div style="flex:1"></div>
                  <span
                    (click)="cancelReply(answerWarning)"
                    class="cancel-reply"
                    >{{ "taxReturns.cancel" | transloco }}</span
                  >
                  <div
                    (click)="
                      saveAnsWarningReply(
                        answerWarning,
                        answerWarning.replyComment
                      )
                    "
                    class="ui primary background button"
                    [ngClass]="{
                      disabled: !answerWarning.replyComment.message,
                      loading: isSavingReply
                    }"
                  >
                    {{ "taxReturns.post" | transloco }}
                  </div>
                </div>
              </div>
              }
            </div>
            @if (answerWarning?.status == 0 && !answerWarning?.replyTo &&
            !readonly()) {
            <div (click)="answerWarning.replyTo = true" class="respond">
              {{ "taxReturns.respond-and-close" | transloco }}
            </div>
            }
          </div>
        </div>
        } }
      </div>
    </div>
  </div>
  }
</div>
}
